"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageService = exports.DEFAULT_OPTIONS = exports.UploadRequestMode = void 0;
const axios_1 = __importDefault(require("axios"));
/** Types of upload requests. */
var UploadRequestMode;
(function (UploadRequestMode) {
    /**
     * Form data mode.
     * @remarks
     * This assumes you're uploading files via FormData and a x-www-urlencoded Content Type. Usually
     * this means you're also sending data via a POST request.
     */
    UploadRequestMode["FormData"] = "FORM_DATA";
    /**
     * Basic mode.
     * @remarks
     * This assumes you're uploading files directly in the request body, with the content type
     * referencing the type of content you're uploading. Usually, this means you're also sending data
     * via a PUT (but sometimes POST) request.
     */
    UploadRequestMode["Basic"] = "BASIC";
})(UploadRequestMode || (exports.UploadRequestMode = UploadRequestMode = {}));
/** Default options for a storage service. */
exports.DEFAULT_OPTIONS = {};
/**
 * Store, retrieve, and query files on a third-party file storage provider.
 *
 * @remarks
 * The storage service is responsible for interfacing with services like AWS S3 or Wasabi. It
 * provides a universal interface for working with these providers.
 *
 * Because it provides this universal interface, we should be able to easily swap out one provider
 * for the other, so long as we've already transferred the existing files between them.
 */
class StorageService {
    constructor(options) {
        this.options = Object.assign(Object.assign({}, exports.DEFAULT_OPTIONS), options);
    }
    /**
     * Uploads a file to the service.
     * @param options - the options to pass to the provider
     */
    uploadFile(_a) {
        var { contents } = _a, rest = __rest(_a, ["contents"]);
        return __awaiter(this, void 0, void 0, function* () {
            const signedRequest = yield this.getSignedUploadUrl(Object.assign(Object.assign({}, rest), { requestMode: UploadRequestMode.Basic }));
            yield (0, axios_1.default)({
                method: 'PUT',
                url: signedRequest.signedUrl,
                headers: signedRequest.data,
                data: contents,
            });
            return signedRequest;
        });
    }
    /**
     * Gets the contents of a file from the storage service.
     * @param fetchOptions the options to pass to getSignedFetchUrl()
     * @returns the file contents, as a string
     */
    getFileContents(fetchOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const fetchUrl = yield this.getSignedFetchUrl(fetchOptions);
            const result = yield (0, axios_1.default)({
                method: 'GET',
                url: fetchUrl.signedUrl,
                headers: fetchUrl.requireHeaders,
                responseType: 'text',
            });
            // Sometimes, if the file is in JSON notation, a JSON object is returned from axios rather
            // than the text contents, so we have to manually convert back to JSON.
            if (typeof result.data !== 'string' &&
                typeof result.data !== 'number' &&
                typeof result.data !== 'boolean') {
                return JSON.stringify(result.data);
            }
            else {
                return result.data.toString();
            }
        });
    }
}
exports.StorageService = StorageService;
//# sourceMappingURL=StorageService.js.map